import {
    createSlice,
    PayloadAction,
    createAsyncThunk,
    createEntityAdapter,
    createSelector,
  } from '@reduxjs/toolkit';
  import type {RootState} from '../../app/rootReducer';
import {getCategories, getCategoriesWithSearch, getCategory, sendQuoteRequestApi} from '../../api/tasksAPI';
import {Status, Category} from '../../interfaces/model';
import {getCookie, removeCookie, setCookie} from '../../utils/cookie';
import {AppThunk} from "../../app/store";
  
  // declaring the types for our state
  interface Task {
    requestResponse: any[];
    status: String;
    activity: any[];
    error: string;
  };


  const CategoriesAdapter = createEntityAdapter<Category>({
    /*@ts-ignore */
    selectId: (entity: any) => entity.id,
  });

const initialState = CategoriesAdapter.getInitialState({
  status: Status.idle,
  error: null,
  successMessage: null,
  data: [],
  requestResponse: [],
});


export const fetchCategories = createAsyncThunk(
    '',
    async () => {
      const response = await getCategories();
      return new Promise<Category[]>(resolve => {
        resolve(response);
      });
    },
);

export const fetchCategoriesWithSearch = createAsyncThunk(
    '',
    async (searchQuery: any) => {
      const response = await getCategoriesWithSearch(searchQuery);
      return new Promise<Category[]>(resolve => {
        resolve(response);
      });
    },
);

export const fetchCategory = (id: any) => createAsyncThunk(
    '',
    async () => {
      const response = await getCategory(id);
      return new Promise<Category[]>(resolve => {
        resolve(response);
      });
    },
);

export const taskSlice = createSlice({
    name: 'task',
    initialState,
    reducers: {
      createCategoryPending(state) {
        state.status = Status.loading;
      },
      createCategoryFailed(state, action) {
        state.status = Status.failed;
        state.error = action.payload;
      },
      createCategorySuccess(state, action) {
        state.status = Status.succeeded;
        state.successMessage = action?.payload ?? 'Success';
      },
      updateCategoryPending(state) {
        state.status = Status.loading;
      },
      updateCategoryFailed(state, action) {
        state.status = Status.failed;
        state.error = action.payload;
      },
      updateCategorySuccess(state, action) {
        state.status = Status.succeeded;
        state.successMessage = action?.payload ?? 'Success';
      },
      deleteCategoryPending(state) {
        state.status = Status.loading;
      },
      deleteCategoryFailed(state, action) {
        state.status = Status.failed;
        state.error = action.payload;
      },
      deleteCategorySuccess(state, action) {
        state.status = Status.succeeded;
        state.successMessage = action?.payload ?? 'Success';
      },
      fetchCategoriesPending(state) {
        state.status = Status.loading;
      },
      fetchCategoriesSuccess(state, action) {
        state.successMessage = null; // Modal success is not shown
        state.status = Status.succeeded;
        state.data = action.payload.data;
      },
      fetchCategoriesFailed(state, action) {
        state.status = Status.failed;
        state.error = action.payload;
      },
      createQuotePending(state) {
        state.status = Status.loading;
      },
      createQuoteFailed(state, action) {
        state.status = Status.failed;
        state.error = action.payload;
      },
      createQuoteSuccess(state, action) {
        state.status = Status.succeeded;
        state.successMessage = action?.payload ?? 'Success';
      },
      removeErr(state) {
        state.error = null;
      },

    },
});

export const {
  createQuotePending,
  createQuoteSuccess,
  createQuoteFailed,
} = taskSlice.actions;

export const sendQuoteRequest = (params: any): AppThunk => async (dispatch) => {
  try {
    dispatch(createQuotePending());
    const {data} = await sendQuoteRequestApi(params);
    dispatch(createQuoteSuccess(data));
    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject();
  }
};


// calling the above actions would be useless if we could not access the data in the state. So, we use something called a selector which allows us to select a value from the state.

//export const taskData = (state: RootState) => state.task.tasks;
// exporting the reducer here, as we need to add this to the store
export default taskSlice.reducer;